import { render, staticRenderFns } from "./checkTest.vue?vue&type=template&id=1d463693&"
import script from "./checkTest.vue?vue&type=script&lang=js&"
export * from "./checkTest.vue?vue&type=script&lang=js&"
import style0 from "./checkTest.vue?vue&type=style&index=0&id=1d463693&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports